<template>
	<div class="plant-loader">
		<div class="solar-system">
			<div class="sun" />
			<div class="orbit orbit-1" />
			<div class="orbit orbit-2" />
			<div class="orbit orbit-3" />
			<div class="planet planet-1" />
			<div class="planet planet-2" />
			<div class="planet planet-3" />
			<div class="star star-1" />
			<div class="star star-2" />
			<div class="star star-3" />
			<div class="star star-4" />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'solar-loader',
	}
</script>

<style lang="scss">
	.plant-loader {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		opacity: 1;
		transition: opacity 0.3s;
	}
	
	.solar-system {
		position: relative;
		width: 40px;
		height: 40px;
	}
	
	/* Central Sun */
	.sun {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 10px;
		height: 10px;
		background: linear-gradient(135deg, #ffffff, #e0e0e0);
		border-radius: 50%;
		box-shadow: 0 0 8px rgba(255, 255, 255, 0.8);
		animation: pulse 2s ease-in-out infinite;
	}
	
	/* Orbital Rings */
	.orbit {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		border: 1px solid rgba(255, 255, 255, 0.2);
		border-radius: 50%;
		animation: fadeIn 0.5s ease-out;
	}
	
	.orbit-1 {
		width: 20px;
		height: 20px;
	}
	
	.orbit-2 {
		width: 30px;
		height: 30px;
	}
	
	.orbit-3 {
		width: 40px;
		height: 40px;
	}
	
	/* Planets */
	.planet {
		position: absolute;
		border-radius: 50%;
		top: 50%;
		left: 50%;
	}
	
	.planet-1 {
		width: 4px;
		height: 4px;
		background: #cccccc;
		animation: orbit1 1.5s linear infinite;
	}
	
	.planet-2 {
		width: 4px;
		height: 4px;
		background: #999999;
		animation: orbit2 2.5s linear infinite;
	}
	
	.planet-3 {
		width: 3px;
		height: 3px;
		background: #666666;
		animation: orbit3 3.5s linear infinite;
	}
	
	/* Stars */
	.star {
		position: absolute;
		width: 1.5px;
		height: 1.5px;
		background: white;
		border-radius: 50%;
		opacity: 0;
		animation: twinkle 2s ease-in-out infinite;
	}
	
	.star-1 {
		top: 3px;
		left: 6px;
		animation-delay: 0.5s;
	}
	
	.star-2 {
		top: 6px;
		right: 5px;
		animation-delay: 1s;
	}
	
	.star-3 {
		bottom: 5px;
		left: 8px;
		animation-delay: 1.5s;
	}
	
	.star-4 {
		bottom: 7px;
		right: 7px;
		animation-delay: 0.3s;
	}
	
	/* Animations */
	@keyframes pulse {
		0%, 100% {
			transform: translate(-50%, -50%) scale(1);
			box-shadow: 0 0 8px rgba(255, 255, 255, 0.8);
		}
		50% {
			transform: translate(-50%, -50%) scale(1.1);
			box-shadow: 0 0 15px rgba(255, 255, 255, 1);
		}
	}
	
	@keyframes orbit1 {
		from {
			transform: translate(-50%, -50%) rotate(0deg) translateX(10px) rotate(0deg);
		}
		to {
			transform: translate(-50%, -50%) rotate(360deg) translateX(10px) rotate(-360deg);
		}
	}
	
	@keyframes orbit2 {
		from {
			transform: translate(-50%, -50%) rotate(0deg) translateX(15px) rotate(0deg);
		}
		to {
			transform: translate(-50%, -50%) rotate(360deg) translateX(15px) rotate(-360deg);
		}
	}

	@keyframes orbit3 {
		from {
			transform: translate(-50%, -50%) rotate(0deg) translateX(20px) rotate(0deg);
		}
		to {
			transform: translate(-50%, -50%) rotate(360deg) translateX(20px) rotate(-360deg);
		}
	}
	
	@keyframes twinkle {
		0%, 100% {
			opacity: 0;
		}
		50% {
			opacity: 1;
		}
	}
	
	@keyframes fadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
</style>
